import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Consultation", body: "We understand your facility, your goals, and what after-dark operations could look like for you." },
  { n: "02", title: "Site Assessment", body: "We review coverage, power availability, and project requirements on your grounds." },
  { n: "03", title: "Custom Proposal", body: "You receive a tailored lighting solution and a transparent commercial quote." },
  { n: "04", title: "Contractor Recommendation", body: "We connect you with qualified, independent installation contractors we know and trust." },
  { n: "05", title: "Project Completion", body: "Final review and handover — your facility, ready beyond daylight." },
];

export default function Process() {
  return (
    <section className="py-24 sm:py-32 bg-[#0B0D0C] border-y hairline" data-testid="process-section">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <Reveal>
          <Eyebrow>How Fairlume Works</Eyebrow>
          <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight max-w-2xl mb-4">
            From First Conversation to First Night
          </h2>
          <p className="text-muted-green text-sm sm:text-base max-w-xl leading-relaxed mb-16">
            Fairlume designs your lighting plan and sources professional systems — then
            recommends trusted independent contractors for the installation itself.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/5 rounded-md overflow-hidden">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="h-full">
              <div className="bg-[#101214] p-7 h-full group hover:bg-[#161B19] transition-colors duration-500" data-testid={`process-step-${i + 1}`}>
                <span className="font-mono-tech text-xs text-[#A7D7A0] tracking-[0.25em]">{s.n}</span>
                <div className="w-8 h-px bg-[#326B46] my-5 group-hover:w-14 transition-all duration-500" />
                <h3 className="font-display font-semibold text-lg tracking-tight">{s.title}</h3>
                <p className="mt-3 text-muted-green text-sm leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
